{
  "layout": {
    "title": "Settings",
    "description": "Manage your account settings and preferences.",
    "adminTitle": "Settings",
    "adminDescription": "Manage your administrative account settings and preferences."
  },
  "nav": {
    "profile": "Profile",
    "business": "Business",
    "password": "Password",
    "appearance": "Appearance",
    "language": "Language",
    "notifications": "Notifications",
    "billing": "Billing"
  },
  "profile": {
    "title": "Profile",
    "description": "Update your personal information",
    "formTitle": "Profile Information",
    "formDescription": "Update your name, email address, and phone number",
    "saving": "Saving...",
    "saved": "Profile updated successfully",
    "saveError": "Failed to update profile",
    "name": "Name",
    "nameDescription": "Your full name",
    "namePlaceholder": "Full name",
    "email": "Email address",
    "emailDescription": "Your email address",
    "emailPlaceholder": "Email address",
    "phone": "Phone number",
    "phoneDescription": "Your phone number with country code",
    "phonePlaceholder": "Phone number",
    "invalidUsername": "Username must be 3-30 characters: lowercase letters, numbers, and underscores",
    "username": "Username",
    "usernameDescription": "Used to sign in. You can change this anytime.",
    "usernamePlaceholder": "username",
    "usernameChecking": "Checking availability...",
    "usernameAvailable": "Username is available",
    "invalidEmail": "Invalid email",
    "legacyTitle": "User Profile",
    "firstLastName": "First & Last name",
    "phoneRequired": "Phone cannot be empty",
    "changePasswordButton": "Change Password",
    "photo": "Profile photo",
    "photoDescription": "Upload a photo for your profile",
    "uploading": "Uploading...",
    "uploadFailed": "Upload failed"
  },
  "business": {
    "title": "Business Profile Settings",
    "description": "Manage your business information and contact details",
    "loadingTitle": "Business Profile",
    "loadingDescription": "Manage your business information",
    "noBusinessTitle": "Business Profile",
    "noBusinessDescription": "No business selected",
    "noBusinessHint": "Select a business to manage its profile.",
    "updating": "Updating...",
    "update": "Update",
    "saved": "Profile successfully updated",
    "uploadFailed": "Upload failed",
    "uploading": "Uploading...",
    "geocodeError": "Could not resolve this address. Pick a suggestion from the list.",
    "imageAlt": "Business",
    "name": "Business name",
    "namePlaceholder": "Your business name",
    "descriptionLabel": "Business description",
    "descriptionPlaceholder": "Describe your business",
    "location": "Location",
    "locationHint": "Start typing your address and choose a suggestion from the list.",
    "locationPlaceholder": "e.g. 123 Main Street, Accra",
    "email": "Business email",
    "emailPlaceholder": "contact@business.com",
    "emailRequired": "Email is required",
    "emailInvalid": "Email is invalid",
    "phone": "Business phone",
    "phonePlaceholder": "+1234567890",
    "industry": "Industry",
    "industryHint": "Select your business industry",
    "industryPlaceholder": "Select an industry",
    "industrySearch": "Search industries...",
    "industryEmpty": "No industry found"
  },
  "password": {
    "title": "Password",
    "description": "Update your password",
    "formTitle": "Change Password",
    "formDescription": "Ensure your account is using a long, random password to stay secure",
    "current": "Current password",
    "new": "New password",
    "confirm": "Confirm password",
    "saved": "Password updated successfully",
    "saveError": "Failed to update password",
    "saving": "Saving...",
    "saveButton": "Save password",
    "minLength": "Must be 8 characters or more",
    "mismatch": "Passwords must match",
    "legacyTitle": "Set new password",
    "legacyDescription": "Kindly enter your old password and provide a new password",
    "legacyBack": "Back",
    "oldPasswordPlaceholder": "Enter your old password",
    "newPasswordPlaceholder": "Enter your new password",
    "confirmPasswordPlaceholder": "Confirm your new password",
    "changeSuccess": "Password successfully changed",
    "changeFailed": "Failed to change password"
  },
  "appearance": {
    "title": "Appearance",
    "description": "Update your account's appearance settings",
    "theme": "Theme",
    "themeDescription": "Select your preferred theme for the application.",
    "light": "Light",
    "dark": "Dark",
    "system": "System"
  },
  "language": {
    "title": "Language",
    "description": "Choose your preferred language for the application.",
    "english": "English",
    "french": "Français",
    "spanish": "Español",
    "saved": "Language updated",
    "active": "Active"
  },
  "notifications": {
    "title": "Notifications",
    "description": "View and manage your recent activity and alerts.",
    "emptyTitle": "No notifications yet",
    "emptyDescription": "When you receive appointment updates, slot requests, and other alerts, they will appear here.",
    "updating": "Updating notification…",
    "pageOf": "Page {{page}} of {{total}}",
    "markAllSuccess": "All notifications marked as read",
    "markAllError": "Could not mark notifications as read",
    "markReadError": "Could not mark notification as read"
  }
}
